__webpack_require__.p = "/wp-content/plugins/app/build/";